export enum TepIntents {
  Edit = 'edit',
  Draft = 'draft',
  Issue = 'issue',
  Undraft = 'undraft',
  Return = 'return',
  Notify = 'notify',
  InlineEdit = 'inline-edit',
  InlineUndraft = 'inline-undraft',
  ManageOfficers = 'manage-officers',
}

export enum LeasesStatuses {
  Mixed = 'MIXED',
  Available = 'AVAILABLE',
  Drafted = 'DRAFTED',
  Issued = 'ISSUED',
}

export enum TepRelevance {
  All = 'all',
  Valid = 'valid',
  Expired = 'expired',
}

export const TEP_RELEVANCE: Record<string, string> = {
  [TepRelevance.All]: 'All',
  [TepRelevance.Valid]: 'Valid TEP',
  [TepRelevance.Expired]: 'Expired TEP',
};

export const ALL_TEP_COLUMNS_IDS = [
  'name',
  'device.imei',
  'lease.company.name',
  'lease.email',
  'lease.plateNumber',
  'lease.draftedAt',
  'lease.startOn',
  'lease.endOn',
  'lease.issuedAt',
  'status',
];
